import React from "react";
import ProductRelateItem from './ProductRelateItem';
class ProductMoreRelate extends React.Component {
  addToCart = (product, redirect, cnt=false)=>{
    let $ = window.jQuery;
    let {cart} = this.props,
    idx = -1;
    if(cart.length)
    {
        idx = cart.findIndex((item)=>parseInt(item.id) === parseInt(product.product_id));
        idx > -1 && 
            (cart[idx].cnt += cnt ? cnt:parseInt($('#qty').val()));
    }
    (!cart.length || idx === -1) && cart.push({id:product.product_id,pcd:product.pcd,title:product.title,
      price: product.price_after_discount,price_origin:product.meta.price,
      category:product.category,
      image: product.image,
      link:product.link,cnt:cnt?cnt:parseInt($('#qty').val())});
    this.props.addToCart(cart, redirect);
  }
  render() {
    let {relate} = this.props,
    {suggestion, parent} = relate;
    
    let suggestionContent = suggestion && suggestion.length ? 
    suggestion.map((item, index)=><ProductRelateItem addToCart={this.addToCart} key={index} product={item} />):null; 
    
    let parentContent = parent && parent.length ? 
    parent.map((item, index)=><ProductRelateItem addToCart={this.addToCart} key={index} product={item} />):null; 
    return (
      <div className="row">
          <div className="w-100 bg-white p-3 mt-3">
              <div className="w-100 product-more-relate">
                  <div className="product-relate-title">
                    <h4 className="text-lg">Gợi ý cho bạn</h4>
                    <hr/>
                    <div className="p-2 w-100 position-relative">
                      {suggestionContent ? 
                      <div className="relate__card__swiper-container swiper-slide-container">
                        <div className="swiper-wrapper">
                        {suggestionContent}
                        </div>
                        {/* Add Arrows */}
                        <div className="swiper-button-next"></div>
                        <div className="swiper-button-prev"></div>
                      </div>
                      :null}
                  </div>
                    
                  </div>
              </div>
          </div>
      
          <div className="w-100 bg-white p-3 mt-3">
              <div className="w-100 product-more-relate">
                  <div className="product-relate-title">
                    <h4 className="text-lg">Sản phẩm cùng loại</h4>
                    <hr/>
                    <div className="p-2 w-100 position-relative">
                      {parentContent ? 
                      <div className="relate__card__swiper-container swiper-slide-container">
                        <div className="swiper-wrapper">
                        {parentContent}
                        </div>
                        {/* Add Arrows */}
                        <div className="swiper-button-next"></div>
                        <div className="swiper-button-prev"></div>
                      </div>
                      :null}
                    </div>
                    
                  </div>
              </div>
          </div>
      
      </div>
    );
  }
}
export default ProductMoreRelate;
